import { IPaperItem } from "src/app/shared/timeline/Timeline.types";
import { LABELS } from "src/app/common/strings";

const PAPERS_ITEMS: IPaperItem[] = [
  {
    title: "Cultural Leaf: A LOD Portal For Exploring The Cultural Heritage",
    authors: ["Dorobat I. C.", "Posea V."],
    publisher: "U.P.B. Sci. Bull., Series C, vol. 86, no. 2",
    period: "2024",
    issn: "2286-3540",
    website: "https://www.scientificbulletin.upb.ro/rev_docs_arhiva/full18f_899864.pdf",
    priority: 13,
  },
  {
    title: "Enhancing the Semantic Access and Visualization for Cultural Heritage: The Romanian Case Study",
    authors: ["Dorobat I. C.", "Posea V.", "Boncea, R."],
    publisher: "In Proceedings of the 19th International Scientific Conference eLearning and Software for Education (eLSE)",
    locality: LABELS.bucharest,
    country: LABELS.romania,
    period: "2023",
    priority: 12,
  },
  {
    title: "Open Data Indicator: An Accumulative Methodology for Measuring the Quality of Open Government Data",
    authors: ["Dorobat I. C.", "Posea V."],
    publisher: "In Proceedings of the 13th International Conference on Electronics, Computers and Artificial Intelligence (ECAI)",
    locality: LABELS.pitesti,
    country: LABELS.romania,
    period: "2021",
    doi: "https://doi.org/10.1109/ECAI52376.2021.9515147",
    website: "https://ieeexplore.ieee.org/document/9515147",
    priority: 11,
  },
  {
    title: "The Power of Regular Expressions in Recognizing Dates and Epochs",
    authors: ["Dorobat I. C.", "Posea V."],
    publisher: "In Proceedings of the 13th International Conference on Electronics, Computers and Artificial Intelligence (ECAI)",
    locality: LABELS.pitesti,
    country: LABELS.romania,
    period: "2021",
    doi: "https://doi.org/10.1109/ECAI52376.2021.9515139",
    website: "https://ieeexplore.ieee.org/document/9515139",
    priority: 10,
  },
  {
    title: "The Usability of Romanian Open Data in the Development of Tourist Applications",
    authors: ["Dorobat I. C.", "Posea V."],
    publisher: "In Proceedings of the 8th International Euro-Mediterranean Conference (EuroMed)",
    country: LABELS.cyprus,
    period: "2021",
    doi: "https://doi.org/10.1007/978-3-030-73043-7_51",
    website: "https://link.springer.com/chapter/10.1007/978-3-030-73043-7_51",
    priority: 9,
  },
  {
    title: "Raising the Interoperability of Cultural Datasets: The Romanian Cultural Heritage Case Study",
    authors: ["Dorobat I. C.", "Posea V."],
    publisher: "In Proceedings of the 17th International European, Mediterranean, and Middle Eastern Conference on Information Systems (EMCIS)",
    locality: LABELS.dubai,
    country: LABELS.unitedArabEmirates,
    period: "2020",
    doi: "https://doi.org/10.1007/978-3-030-63396-7_3",
    website: "https://link.springer.com/chapter/10.1007/978-3-030-63396-7_3",
    priority: 8,
  },
  {
    title: "onIQ: An Ontology-Independent Natural Language Interface for Building SPARQL Queries",
    authors: ["Dorobat I. C.", "Posea V."],
    publisher: "In Proceedings of the 16th International Conference on Intelligent Computer Communication and Processing (ICCP)",
    locality: LABELS.clujNapoca,
    country: LABELS.romania,
    period: "2020",
    doi: "https://doi.org/10.1109/ICCP51029.2020.9266272",
    website: "https://ieeexplore.ieee.org/document/9266272",
    priority: 7,
  },
  {
    title: "IQ Semantic: Semantic Web Intelligent Querying Framework",
    authors: ["Dorobat I. C.", "Posea V."],
    publisher: "In Proceedings of the 26th International conference KNOWLEDGE-BASED ORGANIZATION (KBO), vol. 26, no. 3",
    period: "2020",
    doi: "https://doi.org/10.2478/kbo-2020-0122",
    website: "https://sciendo.com/article/10.2478/kbo-2020-0122",
    priority: 6,
  },
  {
    title: "Evolving the DSpace Storage into Linked Data",
    authors: ["Dorobat I. C.", "Posea V."],
    publisher: "In Proceedings of the 12th International Conference on Electronics, Computers and Artificial Intelligence (ECAI)",
    locality: LABELS.bucharest,
    country: LABELS.romania,
    period: "2020",
    doi: "http://dx.doi.org/10.1109/ECAI50035.2020.9223189",
    website: "https://ieeexplore.ieee.org/document/9223189",
    priority: 5,
  },
  {
    title: "Improving the Quality of Linked Data Using String Suggestions",
    authors: ["Dorobat I. C.", "Rinciog O.", "Posea V.", "Muraru G. C."],
    publisher: "In Proceedings of the 16th International Scientific Conference eLearning and Software for Education (eLSE), vol. 2",
    locality: LABELS.bucharest,
    country: LABELS.romania,
    period: "2020",
    doi: "http://dx.doi.org/10.12753/2066-026X-20-133",
    website: "https://proceedings.elseconference.eu/index.php?paper=64ca40407fb060b4bbe20d1597728b01",
    priority: 4,
  },
  {
    title: "eLIF: European Life Index Framework - An Analysis for the Case of European Union Countries",
    authors: ["Dorobat I. C.", "Posea V."],
    publisher: "In International Journal on Advances in Systems and Measurements, vol. 12, no. 3 & 4",
    period: "2019",
    issn: "1942-261x",
    website: "https://personales.upv.es/thinkmind/dl/journals/sysmea/sysmea_v12_n34_2019/sysmea_v12_n34_2019_5.pdf",
    priority: 3,
  },
  {
    title: "Enriching the Cultural Heritage Metadata Using Historical Events: A Graph-Based Representation",
    authors: ["Dorobat I. C.", "Posea V."],
    publisher: "In Proceedings of the 23rd International Conference on Theory and Practice of Digital Libraries (TPDL)",
    locality: LABELS.oslo,
    country: LABELS.norway,
    period: "2019",
    doi: "http://dx.doi.org/10.1007/978-3-030-30760-8_30",
    website: "https://link.springer.com/chapter/10.1007/978-3-030-30760-8_30",
    priority: 2,
  },
  {
    title: "Quality of Life Index Analysis for the Case of Romanian Regions",
    authors: ["Dorobat I. C.", "Rinciog O.", "Posea V.", "Muraru G. C."],
    publisher: "In Proceedings of the 13th International Conference on Digital Society and eGovernments (ICDS)",
    locality: LABELS.athens,
    country: LABELS.greece,
    period: "2019",
    website: "https://personales.upv.es/thinkmind/dl/conferences/icds/icds_2019/icds_2019_2_30_10030.pdf",
    priority: 1,
  },
  {
    title: "Route Suggestion for Visiting Museums Using Semantic Data",
    authors: ["Dorobat I. C.", "Rinciog O.", "Posea V."],
    // TODO: vol?
    publisher: "In Proceedings of the 13th International Scientific Conference eLearning and Software for Education (eLSE)",
    locality: LABELS.bucharest,
    country: LABELS.romania,
    period: "2017",
    doi: "http://dx.doi.org/10.12753/2066-026X-17-180",
    website: "https://proceedings.elseconference.eu/index.php?r=site/index&year=2017&index=papers&vol=26&paper=8fabfad4738f655ab5091906dbf14139",
    priority: 0,
  },
];

export { PAPERS_ITEMS };
